'use strict';exports.__esModule = true;exports.getCitiesLinksValues = exports.getRoomFilterLinks = exports.getPriceFilterLinks = exports.MAX_PRICE_FOR_CAROUSEL = exports.ROOT_ROUTE = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ROOT_ROUTE = exports.ROOT_ROUTE = '/';
var MAX_PRICE_FOR_CAROUSEL = exports.MAX_PRICE_FOR_CAROUSEL = 1000000;

var cities = [
{ name: 'tel-aviv-yafo', localisation: { en: 'Tel Aviv-Yafo', he: 'תל אביב יפו', ru: 'Тель Авив Яффо', fr: 'Tel Aviv-Yafo' } },
{ name: 'netanya', localisation: { en: 'Netanya', he: 'נתניה', ru: 'Нетания', fr: 'Netanya' } },
{ name: 'rishon-letsiyon', localisation: { en: 'Rishon LeTsiyon', he: 'ראשון לציון', ru: 'Ришон ле-Цион', fr: 'Rishon LeTsiyon' } },
{ name: 'rehovot', localisation: { en: 'Rehovot', he: 'רחובות', ru: 'Реховот', fr: 'Rehovot' } },
{ name: 'haifa', localisation: { en: 'Haifa', he: 'חיפה', ru: 'Хайфа', fr: 'Haifa' } },
{ name: 'ashdod', localisation: { en: 'Ashdod', he: 'אשדוד', ru: 'Ашдод', fr: 'Ashdod' } },
{ name: 'holon', localisation: { en: 'Holon', he: 'חולון', ru: 'Холон', fr: 'Holon' } },
{ name: 'bat-yam', localisation: { en: 'Bat Yam', he: 'בת ים', ru: 'Бат Ям', fr: 'Bat Yam' } },
{ name: 'petah-tikva', localisation: { en: 'Petah Tikva', he: 'פתח תקווה', ru: 'Петах-Тиква', fr: 'Petah Tikva' } },
{ name: '', localisation: { en: 'General search', he: 'חיפוש כללי', ru: 'Общий поиск', fr: 'Recherche générale' } }];


var priceFilter = [850000, 950000, 1050000, 1250000, 1450000];

var roomOptions = function roomOptions(translate) {return [
  { id: 1, label: '1 ' + translate('room'), value: 1 },
  { id: 2, label: '2 ' + translate('rooms'), value: 2 },
  { id: 3, label: '3 ' + translate('rooms'), value: 3 },
  { id: 4, label: '4 ' + translate('rooms'), value: 4 },
  { id: 5, label: '5 ' + translate('rooms'), value: 5 },
  { id: 6, label: '6 +', value: 6 }];};


var buildPriceLink = function buildPriceLink(price) {return {
    value: '/homes/buy/price_0-' + price,
    label: '\u20AA' + (0, _beautifyNumber2.default)(price) };};


var buildRoomLink = function buildRoomLink(room) {return {
    value: '/homes/buy/rooms_' + room.value,
    label: room.label };};


var getPriceFilterLinks = exports.getPriceFilterLinks = priceFilter.map(buildPriceLink);
var getRoomFilterLinks = exports.getRoomFilterLinks = function getRoomFilterLinks(translate) {return roomOptions(translate('search_box', 'searchContainer')).
  map(buildRoomLink);};

var getCitiesLinksValues = exports.getCitiesLinksValues = function getCitiesLinksValues(locale, type) {return cities.map(function (city) {return {
      value: '/homes/' + type + '/' + city.name,
      label: (0, _get2.default)(city, 'localisation.' + locale) };});};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/helpers.js
// module id = 1211
// module chunks = 0